<template>
  <v-card height="100%" tile id="vehicle-type">
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title class="col-6">
          {{ resx.labels.vehiclesType }}
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
      </v-toolbar>
    </v-card-title>

    <v-card-text>
      <v-row mr-4 class="count-items">
        <v-spacer></v-spacer>
        <v-col shrink>
          <span v-if="items.length > 0">{{
            `${
              resx.labels.countItems
            } ${resx.labels.vehiclesType.toLowerCase()}: ${count}`
          }}</span>
        </v-col>
      </v-row>
      <v-row class="table-container">
        <v-col fill-height class="scrollable">
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading=loading
            :no-data-text="resx.messages.noVehicleTypesAvailable"
            :no-results-text="resx.messages.noVehicleTypesFound"
            fixed-header
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            ref="dataTable"
            sort-by="name"
            loading-text=""
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>
            <template v-slot:item.name="{ item }">
              <td>
                <a @click.prevent="edit(item)">{{ item.name }}</a>
              </td>
            </template>
            <template v-slot:item.comments="{ item }">
              <td class="hidden-xs-only">{{ item.comments }}</td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="edit(item)">
                      <v-list-item-action>
                        <v-icon color="primary">mode_edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.edit
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="remove(item)">
                      <v-list-item-action>
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.delete
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="create"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-row>
        <edit-vehicle
          v-model="openDialog"
          v-on:close="onClose"
          v-on:save="onSave"
        ></edit-vehicle>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";

import store from "@/store/store";
import vehicleTypeService from "@/services/VehicleTypeService";

import editVehicle from "@/components/views/vehicles-type/edit-vehicle-type.view.vue";

import moment from "moment";
import BarLoader from "@/components/common/bar-loader.vue";

export default {
  async mounted() {
    this.items = await vehicleTypeService.list();
    this.loading = false;
  },
  components: {
    editVehicle,
    BarLoader
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      headers: [
        {
          text: resx.labels.name,
          value: "name"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.comments,
          value: "comments"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        }
      ],
      items: [],
      openDialog: null,
      loading: true
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    create() {
      this.openDialog = {
        selectedItem: { obligations: [] }
      };
    },
    edit(vehicle) {
      this.openDialog = {
        selectedItem: JSON.parse(JSON.stringify(vehicle))
      };
    },
    async remove(vehicle) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.vehicle.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteVehicleTypeMessage,
          vehicle.name
        )
      });
      let deleted = await vehicleTypeService.remove(vehicle._id);
      const index = this.items.findIndex(
        o => o._id == vehicle._id && deleted.isDeleted
      );
      this.items.splice(index, 1);
    },
    onClose() {
      this.openDialog = null;
    },
    onSave(action) {
      if (action.isNew) {
        this.items.push(action.item);
      } else {
        this.$set(
          this.items,
          this.items.findIndex(i => i._id == action.item._id),
          action.item
        );
      }
      this.onClose();
    },
    parseDate(d) {
      return moment(d).format(store.state.constants.DATE_FORMAT);
    },
  },
  computed: {
    count: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    }
  },
  mixins: []
};
</script>

<style lang="scss">
#vehicle-type {
  .v-card__text .table-container {
    padding-bottom: 50px;
  }
}

.addButton.v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom {
  position: fixed;
  bottom: 101px;
  right: 35px;
}
</style>
